import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const useStyles = makeStyles((theme) => ({
  customBackgroundInput: {
    "& .MuiInputBase-root": {
      backgroundColor: colors.gray5,
      borderRadius: 6,
      border: `1px solid ${colors.gray4}`,
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "#555",
    },
  },
}));

export { useStyles as PopupStyle };
